import { Box, xcss } from '@atlaskit/primitives';
import { Show } from '@atlaskit/primitives/responsive';
import React from 'react';
import { DesktopFilters } from './DesktopFilters';
import { MobileFilters } from './MobileFilters';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const wrapperStyles = xcss({
  fontFamily: 'font.family.brand.body'
});
export const Filters = _ref => {
  let {
    filterOptions,
    filterDefinitions,
    filterStatus = {},
    selectedOptions = {},
    selectedSortOption,
    showAllFilters = false,
    sortOptions,
    onClearFilter,
    onClearAllFilters,
    onShowAllFilters,
    onSelectedOptionsChange,
    onSelectedSortOptionChange,
    onApplyFilters,
    onCloseMobileDialog,
    useAtlassianAppsExperimentNewUI = false
  } = _ref;
  if (!filterDefinitions.length) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Box, {
    xcss: wrapperStyles,
    children: [/*#__PURE__*/_jsx(Show, {
      below: "sm",
      as: "span",
      children: /*#__PURE__*/_jsx(MobileFilters, {
        filterDefinitions: filterDefinitions,
        filterOptions: filterOptions,
        selectedOptions: selectedOptions,
        sortOptions: sortOptions,
        selectedSortOption: selectedSortOption,
        filterStatus: filterStatus,
        onClearAllFilters: onClearAllFilters,
        onSelectedOptionsChange: onSelectedOptionsChange,
        onSelectedSortOptionChange: onSelectedSortOptionChange,
        onApplyFilters: onApplyFilters,
        onCloseMobileDialog: onCloseMobileDialog,
        useAtlassianAppsExperimentNewUI: useAtlassianAppsExperimentNewUI
      })
    }), /*#__PURE__*/_jsx(Show, {
      above: "sm",
      as: "span",
      children: /*#__PURE__*/_jsx(DesktopFilters, {
        filterDefinitions: filterDefinitions,
        filterOptions: filterOptions,
        filterStatus: filterStatus,
        selectedOptions: selectedOptions,
        onClearFilter: onClearFilter,
        onClearAllFilters: onClearAllFilters,
        onSelectedOptionsChange: onSelectedOptionsChange,
        showAllFilters: showAllFilters,
        onShowAllFilters: onShowAllFilters
      })
    })]
  });
};